export default __webpack_public_path__ + "static/backgroundDirectors-00c8376c485fbb74c660b58123c12dee.jpg";